import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import CloseBtn from '../CloseBtn'

const ConfirmPayment = ({onHide,show,onSubmit,remark,setRemark}) => {
  return (
       <Modal show={show} onHide={onHide} centered>
        <CloseBtn onClick={onHide} color="#bf352b" />
        <Modal.Header>
          <Modal.Title>Confirm Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Add a remark for confirming payment..."
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            Confirm Payment
          </Button>
        </Modal.Footer>
      </Modal>
  )
}

export default ConfirmPayment